module.exports = __webpack_public_path__ + "assets/78e9a1a299a52921d59f674a2f26bcfe.mp3";